(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  ready(function () {
    var builder = document.getElementById(
      'GfdEstimateBuilder'
    );

    if (!builder) {
      return;
    }

    var panel = document.getElementById(
      'GfdEstimatePanel'
    );

    var toggleButton = builder.querySelector(
      '.gfd-estimate__toggle'
    );

    var markupInput = document.getElementById(
      'GfdEstimateMarkup'
    );

    var applyMarkupButton = document.getElementById(
      'GfdApplyMarkup'
    );

    var resetPricesButton = document.getElementById(
      'GfdResetPrices'
    );

    var printButton = document.getElementById(
      'GfdPrintEstimate'
    );

    var laborInput = document.getElementById(
      'GfdEstimateLabor'
    );

    var deliveryInput = document.getElementById(
      'GfdEstimateDelivery'
    );

    var otherInput = document.getElementById(
      'GfdEstimateOther'
    );

    var discountInput = document.getElementById(
      'GfdEstimateDiscount'
    );

    var taxRateInput = document.getElementById(
      'GfdEstimateTaxRate'
    );

    var projectSelect = document.getElementById(
      'GfdEstimateProjectSelect'
    );

    var saveEstimateButton = document.getElementById(
      'GfdSaveEstimate'
    );

    var saveMessage = document.getElementById(
      'GfdEstimateSaveMessage'
    );

    if (!panel || !toggleButton) {
      return;
    }

    /*
     * ----------------------------------------------------------
     * Shared contractor Note Templates
     * ----------------------------------------------------------
     *
     * Uses the SAME localStorage key as My Projects:
     *   gfd_note_templates_customer_<customer id>
     *
     * This means notes created in the Contractor Portal appear
     * in the cart, and notes created in the cart appear in the
     * Contractor Portal for the same logged-in contractor.
     */
    var customerId =
      builder.getAttribute('data-customer-id') || '';

    var noteTemplatesKey =
      'gfd_note_templates_customer_' + customerId;

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function loadNoteTemplates() {
      try {
        var saved = JSON.parse(
          localStorage.getItem(noteTemplatesKey)
        );

        if (Array.isArray(saved)) {
          return saved;
        }

        /*
         * Backward compatibility with the older split
         * Estimate Notes / Invoice Notes template format.
         */
        if (saved && typeof saved === 'object') {
          var migrated = [];

          if (Array.isArray(saved.estimate)) {
            migrated = migrated.concat(
              saved.estimate
            );
          }

          if (Array.isArray(saved.invoice)) {
            migrated = migrated.concat(
              saved.invoice
            );
          }

          if (migrated.length > 0) {
            saveNoteTemplates(migrated);
            return migrated;
          }
        }
      } catch (error) {
        // Use an empty list below.
      }

      return [];
    }

    function saveNoteTemplates(templates) {
      localStorage.setItem(
        noteTemplatesKey,
        JSON.stringify(
          Array.isArray(templates)
            ? templates
            : []
        )
      );
    }

    function makeNoteTemplateId() {
      return (
        'note_' +
        Date.now() +
        '_' +
        Math.random().toString(36).slice(2, 8)
      );
    }

    function getNoteTemplate(templateId) {
      return loadNoteTemplates().find(
        function (template) {
          return template.id === templateId;
        }
      ) || null;
    }

    function buildNoteTemplateOptions() {
      var html =
        '<option value="">Choose saved note…</option>';

      loadNoteTemplates().forEach(
        function (template) {
          html +=
            '<option value="' +
              escapeHtml(template.id) +
            '">' +
              escapeHtml(
                template.name || 'Untitled note'
              ) +
            '</option>';
        }
      );

      return html;
    }

    function refreshCartNoteTemplateSelect(dialog) {
      if (!dialog) {
        return;
      }

      var select = dialog.querySelector(
        '[data-cart-note-template-select]'
      );

      if (!select) {
        return;
      }

      var selected = select.value;

      select.innerHTML =
        buildNoteTemplateOptions();

      if (
        selected &&
        getNoteTemplate(selected)
      ) {
        select.value = selected;
      }
    }

    function renderCartNoteTemplateList(dialog) {
      var list = dialog.querySelector(
        '[data-cart-note-template-list]'
      );

      if (!list) {
        return;
      }

      var templates =
        loadNoteTemplates();

      if (templates.length === 0) {
        list.innerHTML =
          '<p class="gfd-cart-note-manager__empty">' +
            'No saved note templates yet.' +
          '</p>';
        return;
      }

      list.innerHTML = templates.map(
        function (template) {
          return (
            '<button ' +
              'type="button" ' +
              'class="gfd-cart-note-manager__item" ' +
              'data-cart-edit-note-template="' +
                escapeHtml(template.id) +
              '">' +
                '<strong>' +
                  escapeHtml(
                    template.name ||
                    'Untitled note'
                  ) +
                '</strong>' +
                '<span>' +
                  escapeHtml(
                    template.body || ''
                  ) +
                '</span>' +
            '</button>'
          );
        }
      ).join('');
    }

    function resetCartNoteTemplateManager(
      manager
    ) {
      manager.querySelector(
        '[data-cart-note-template-id]'
      ).value = '';

      manager.querySelector(
        '[data-cart-note-template-name]'
      ).value = '';

      manager.querySelector(
        '[data-cart-note-template-body]'
      ).value = '';

      manager.querySelector(
        '[data-cart-update-note-template]'
      ).disabled = true;

      manager.querySelector(
        '[data-cart-delete-note-template]'
      ).disabled = true;
    }

    function openCartNoteTemplateManager(
      dialog
    ) {
      var manager = dialog.querySelector(
        '[data-cart-note-template-manager]'
      );

      if (!manager) {
        return;
      }

      resetCartNoteTemplateManager(
        manager
      );

      renderCartNoteTemplateList(
        dialog
      );

      manager.showModal();
    }

    function selectCartNoteTemplateForEdit(
      dialog,
      templateId
    ) {
      var manager = dialog.querySelector(
        '[data-cart-note-template-manager]'
      );

      if (!manager) {
        return;
      }

      var template =
        getNoteTemplate(templateId);

      if (!template) {
        return;
      }

      manager.querySelector(
        '[data-cart-note-template-id]'
      ).value = template.id;

      manager.querySelector(
        '[data-cart-note-template-name]'
      ).value =
        template.name || '';

      manager.querySelector(
        '[data-cart-note-template-body]'
      ).value =
        template.body || '';

      manager.querySelector(
        '[data-cart-update-note-template]'
      ).disabled = false;

      manager.querySelector(
        '[data-cart-delete-note-template]'
      ).disabled = false;
    }

    function saveNewCartNoteTemplate(
      dialog
    ) {
      var manager = dialog.querySelector(
        '[data-cart-note-template-manager]'
      );

      if (!manager) {
        return;
      }

      var name = manager.querySelector(
        '[data-cart-note-template-name]'
      ).value.trim();

      var body = manager.querySelector(
        '[data-cart-note-template-body]'
      ).value;

      if (!name) {
        window.alert(
          'Please enter a template name.'
        );
        return;
      }

      if (!body.trim()) {
        window.alert(
          'Please enter the reusable note.'
        );
        return;
      }

      var templates =
        loadNoteTemplates();

      templates.push({
        id: makeNoteTemplateId(),
        name: name,
        body: body,
        createdAt:
          new Date().toISOString(),
        updatedAt:
          new Date().toISOString()
      });

      saveNoteTemplates(
        templates
      );

      resetCartNoteTemplateManager(
        manager
      );

      refreshCartNoteTemplateSelect(
        dialog
      );

      renderCartNoteTemplateList(
        dialog
      );
    }

    function updateCartNoteTemplate(
      dialog
    ) {
      var manager = dialog.querySelector(
        '[data-cart-note-template-manager]'
      );

      if (!manager) {
        return;
      }

      var templateId = manager.querySelector(
        '[data-cart-note-template-id]'
      ).value;

      var name = manager.querySelector(
        '[data-cart-note-template-name]'
      ).value.trim();

      var body = manager.querySelector(
        '[data-cart-note-template-body]'
      ).value;

      if (!templateId) {
        return;
      }

      if (!name || !body.trim()) {
        window.alert(
          'Template name and note are required.'
        );
        return;
      }

      var templates =
        loadNoteTemplates();

      var template = templates.find(
        function (item) {
          return item.id === templateId;
        }
      );

      if (!template) {
        return;
      }

      template.name = name;
      template.body = body;
      template.updatedAt =
        new Date().toISOString();

      saveNoteTemplates(
        templates
      );

      refreshCartNoteTemplateSelect(
        dialog
      );

      renderCartNoteTemplateList(
        dialog
      );
    }

    function deleteCartNoteTemplate(
      dialog
    ) {
      var manager = dialog.querySelector(
        '[data-cart-note-template-manager]'
      );

      if (!manager) {
        return;
      }

      var templateId = manager.querySelector(
        '[data-cart-note-template-id]'
      ).value;

      if (!templateId) {
        return;
      }

      var template =
        getNoteTemplate(templateId);

      if (!template) {
        return;
      }

      if (
        !window.confirm(
          'Delete "' +
            (
              template.name ||
              'Untitled note'
            ) +
          '"?'
        )
      ) {
        return;
      }

      var templates =
        loadNoteTemplates().filter(
          function (item) {
            return (
              item.id !== templateId
            );
          }
        );

      saveNoteTemplates(
        templates
      );

      resetCartNoteTemplateManager(
        manager
      );

      refreshCartNoteTemplateSelect(
        dialog
      );

      renderCartNoteTemplateList(
        dialog
      );
    }

    function syncLiveBuilderValues() {
      /*
       * Cloning/moving the live builder should preserve form values,
       * but this ensures calculations and print-only values are current.
       */
      preparePrintValues();
      updateTotals();
    }

    function makeInvoiceNumber(
      estimateNumber
    ) {
      var number =
        String(estimateNumber || '');

      if (/^EST-/i.test(number)) {
        return number.replace(
          /^EST-/i,
          'INV-'
        );
      }

      if (number) {
        return 'INV-' + number;
      }

      return (
        'INV-' +
        new Date()
          .toISOString()
          .slice(0, 10)
          .replace(/-/g, '')
      );
    }

    function printCartBuilderFromDialog(
      dialog,
      mode
    ) {
      if (!dialog) {
        return;
      }

      syncLiveBuilderValues();

      var heading = builder.querySelector(
        '.gfd-estimate__header h2'
      );

      var estimateNumberInput =
        document.getElementById(
          'GfdEstimateNumber'
        );

      var dateInput =
        document.getElementById(
          'GfdEstimateDate'
        );

      var expirationInput =
        document.getElementById(
          'GfdEstimateExpiration'
        );

      var grandTotalLabel =
        builder.querySelector(
          '.gfd-estimate__grand-total dt'
        );

      var labels =
        builder.querySelectorAll(
          '.gfd-estimate__form-grid > label'
        );

      var original = {
        heading:
          heading
            ? heading.textContent
            : '',
        estimateNumber:
          estimateNumberInput
            ? estimateNumberInput.value
            : '',
        grandTotalLabel:
          grandTotalLabel
            ? grandTotalLabel.textContent
            : '',
        labelTexts: []
      };

      labels.forEach(function (label) {
        var textNode = Array.prototype.find.call(
          label.childNodes,
          function (node) {
            return (
              node.nodeType ===
              Node.TEXT_NODE
            );
          }
        );

        original.labelTexts.push({
          label: label,
          node: textNode,
          text:
            textNode
              ? textNode.nodeValue
              : ''
        });
      });

      function setLabelText(
        match,
        replacement
      ) {
        original.labelTexts.forEach(
          function (item) {
            if (
              item.node &&
              String(item.text)
                .trim()
                .toLowerCase() ===
                String(match)
                  .trim()
                  .toLowerCase()
            ) {
              item.node.nodeValue =
                '\n                    ' +
                replacement +
                '\n                    ';
            }
          }
        );
      }

      function restorePrintMode() {
        builder.classList.remove(
          'gfd-invoice-mode'
        );

        if (heading) {
          heading.textContent =
            original.heading;
        }

        if (estimateNumberInput) {
          estimateNumberInput.value =
            original.estimateNumber;
        }

        if (grandTotalLabel) {
          grandTotalLabel.textContent =
            original.grandTotalLabel;
        }

        original.labelTexts.forEach(
          function (item) {
            if (item.node) {
              item.node.nodeValue =
                item.text;
            }
          }
        );

        window.removeEventListener(
          'afterprint',
          restorePrintMode
        );
      }

      if (mode === 'invoice') {
        builder.classList.add(
          'gfd-invoice-mode'
        );

        if (heading) {
          heading.textContent =
            'Invoice';
        }

        if (estimateNumberInput) {
          estimateNumberInput.value =
            makeInvoiceNumber(
              original.estimateNumber
            );
        }

        setLabelText(
          'Estimate number',
          'Invoice number'
        );

        setLabelText(
          'Estimate date',
          'Invoice date'
        );

        setLabelText(
          'Valid until',
          'Due date'
        );

        if (grandTotalLabel) {
          grandTotalLabel.textContent =
            'Amount due';
        }
      }

      dialog.scrollTop = 0;

      var content = dialog.querySelector(
        '.gfd-cart-print-dialog__content'
      );

      if (content) {
        content.scrollTop = 0;
      }

      window.addEventListener(
        'afterprint',
        restorePrintMode
      );

      window.requestAnimationFrame(
        function () {
          window.requestAnimationFrame(
            function () {
              window.print();

              /*
               * Fallback for browsers that do not reliably
               * fire afterprint.
               */
              window.setTimeout(
                restorePrintMode,
                1200
              );
            }
          );
        }
      );
    }

    function openCartPrintDialog() {
      /*
       * Keep the live builder, rather than rebuilding it.
       * This guarantees the review window shows the exact values
       * the contractor just entered in the cart.
       */
      var originalParent =
        builder.parentNode;

      var originalNextSibling =
        builder.nextSibling;

      var dialog =
        document.createElement('dialog');

      dialog.className =
        'gfd-cart-print-dialog';

      dialog.innerHTML =
        '<div class="gfd-cart-print-dialog__toolbar">' +

          '<button ' +
            'type="button" ' +
            'class="button" ' +
            'data-cart-print-estimate' +
          '>' +
            'Print Estimate' +
          '</button>' +

          '<button ' +
            'type="button" ' +
            'class="button button--secondary" ' +
            'data-cart-print-invoice' +
          '>' +
            'Print Invoice' +
          '</button>' +

          '<button ' +
            'type="button" ' +
            'class="button button--secondary" ' +
            'data-cart-print-close' +
          '>' +
            'Close' +
          '</button>' +

        '</div>' +

        '<div class="gfd-cart-print-dialog__content">' +

          '<div class="gfd-cart-note-template-bar">' +

            '<div class="gfd-cart-note-template-bar__copy">' +
              '<strong>Select Note Template</strong>' +
              '<span>Choose any saved note, then edit Notes &amp; Terms below for this job if needed. Editing this job will not change the saved template.</span>' +
            '</div>' +

            '<div class="gfd-cart-note-template-bar__controls">' +

              '<select data-cart-note-template-select>' +
                buildNoteTemplateOptions() +
              '</select>' +

              '<button ' +
                'type="button" ' +
                'class="button button--secondary" ' +
                'data-cart-use-note-template' +
              '>' +
                'Use Template' +
              '</button>' +

              '<button ' +
                'type="button" ' +
                'class="button button--secondary" ' +
                'data-cart-manage-note-templates' +
              '>' +
                'Manage Templates' +
              '</button>' +

            '</div>' +

          '</div>' +

          '<div data-cart-live-builder-slot></div>' +

          '<dialog ' +
            'class="gfd-cart-note-manager" ' +
            'data-cart-note-template-manager' +
          '>' +

            '<div class="gfd-cart-note-manager__content">' +

              '<div class="gfd-cart-note-manager__header">' +
                '<div>' +
                  '<p class="gfd-estimate__eyebrow">Saved Notes</p>' +
                  '<h3>Manage Note Templates</h3>' +
                '</div>' +

                '<button ' +
                  'type="button" ' +
                  'class="gfd-cart-note-manager__close" ' +
                  'data-cart-note-manager-close' +
                '>' +
                  '×' +
                '</button>' +
              '</div>' +

              '<input ' +
                'type="hidden" ' +
                'data-cart-note-template-id ' +
                'value=""' +
              '>' +

              '<label>' +
                'Template name' +
                '<input ' +
                  'type="text" ' +
                  'data-cart-note-template-name ' +
                  'placeholder="Example: Standard Terms"' +
                '>' +
              '</label>' +

              '<label>' +
                'Reusable note' +
                '<textarea ' +
                  'rows="8" ' +
                  'data-cart-note-template-body ' +
                  'placeholder="Enter the reusable note or terms here."' +
                '></textarea>' +
              '</label>' +

              '<div class="gfd-cart-note-manager__actions">' +

                '<button ' +
                  'type="button" ' +
                  'class="button" ' +
                  'data-cart-save-new-note-template' +
                '>' +
                  'Save as New Template' +
                '</button>' +

                '<button ' +
                  'type="button" ' +
                  'class="button button--secondary" ' +
                  'data-cart-update-note-template ' +
                  'disabled' +
                '>' +
                  'Update Selected Template' +
                '</button>' +

                '<button ' +
                  'type="button" ' +
                  'class="button button--secondary" ' +
                  'data-cart-delete-note-template ' +
                  'disabled' +
                '>' +
                  'Delete Selected Template' +
                '</button>' +

                '<button ' +
                  'type="button" ' +
                  'class="button button--secondary" ' +
                  'data-cart-note-manager-close' +
                '>' +
                  'Close' +
                '</button>' +

              '</div>' +

              '<div ' +
                'class="gfd-cart-note-manager__list" ' +
                'data-cart-note-template-list' +
              '></div>' +

            '</div>' +
          '</dialog>' +

        '</div>';

      document.body.appendChild(
        dialog
      );

      var liveSlot = dialog.querySelector(
        '[data-cart-live-builder-slot]'
      );

      liveSlot.appendChild(
        builder
      );

      /*
       * Ensure the full estimate panel is visible inside
       * the review popup.
       */
      panel.removeAttribute(
        'hidden'
      );

      toggleButton.setAttribute(
        'aria-expanded',
        'true'
      );

      toggleButton.textContent =
        'Close Estimate';

      syncLiveBuilderValues();

      function restoreBuilderAndClose() {
        if (
          originalNextSibling &&
          originalNextSibling.parentNode ===
            originalParent
        ) {
          originalParent.insertBefore(
            builder,
            originalNextSibling
          );
        } else {
          originalParent.appendChild(
            builder
          );
        }

        dialog.remove();
      }

      dialog.addEventListener(
        'close',
        restoreBuilderAndClose,
        { once: true }
      );

      dialog.addEventListener(
        'click',
        function (event) {
          var closeButton =
            event.target.closest(
              '[data-cart-print-close]'
            );

          var printEstimateButton =
            event.target.closest(
              '[data-cart-print-estimate]'
            );

          var printInvoiceButton =
            event.target.closest(
              '[data-cart-print-invoice]'
            );

          var useTemplateButton =
            event.target.closest(
              '[data-cart-use-note-template]'
            );

          var manageTemplatesButton =
            event.target.closest(
              '[data-cart-manage-note-templates]'
            );

          var managerCloseButton =
            event.target.closest(
              '[data-cart-note-manager-close]'
            );

          var editTemplateButton =
            event.target.closest(
              '[data-cart-edit-note-template]'
            );

          var saveTemplateButton =
            event.target.closest(
              '[data-cart-save-new-note-template]'
            );

          var updateTemplateButton =
            event.target.closest(
              '[data-cart-update-note-template]'
            );

          var deleteTemplateButton =
            event.target.closest(
              '[data-cart-delete-note-template]'
            );

          if (closeButton) {
            dialog.close();
            return;
          }

          if (printEstimateButton) {
            printCartBuilderFromDialog(
              dialog,
              'estimate'
            );
            return;
          }

          if (printInvoiceButton) {
            printCartBuilderFromDialog(
              dialog,
              'invoice'
            );
            return;
          }

          if (useTemplateButton) {
            var select = dialog.querySelector(
              '[data-cart-note-template-select]'
            );

            if (
              !select ||
              !select.value
            ) {
              window.alert(
                'Please choose a saved note first.'
              );
              return;
            }

            var template =
              getNoteTemplate(
                select.value
              );

            if (!template) {
              return;
            }

            var noteField =
              document.getElementById(
                'GfdEstimateNotes'
              );

            if (noteField) {
              noteField.value =
                template.body || '';

              noteField.dispatchEvent(
                new Event(
                  'input',
                  { bubbles: true }
                )
              );
            }

            return;
          }

          if (manageTemplatesButton) {
            openCartNoteTemplateManager(
              dialog
            );
            return;
          }

          if (managerCloseButton) {
            var manager = dialog.querySelector(
              '[data-cart-note-template-manager]'
            );

            if (manager) {
              manager.close();
            }
            return;
          }

          if (editTemplateButton) {
            selectCartNoteTemplateForEdit(
              dialog,
              editTemplateButton.getAttribute(
                'data-cart-edit-note-template'
              )
            );
            return;
          }

          if (saveTemplateButton) {
            saveNewCartNoteTemplate(
              dialog
            );
            return;
          }

          if (updateTemplateButton) {
            updateCartNoteTemplate(
              dialog
            );
            return;
          }

          if (deleteTemplateButton) {
            deleteCartNoteTemplate(
              dialog
            );
          }
        }
      );

      dialog.showModal();
    }

    function getLineRows() {
      return Array.prototype.slice.call(
        builder.querySelectorAll(
          '.gfd-estimate__line'
        )
      );
    }

    function numberValue(input) {
      if (!input) {
        return 0;
      }

      var value = parseFloat(input.value);

      return Number.isFinite(value)
        ? value
        : 0;
    }

    function centsToDollars(cents) {
      var numericCents = parseInt(cents, 10);

      if (!Number.isFinite(numericCents)) {
        return 0;
      }

      return numericCents / 100;
    }

    function roundMoney(value) {
      return (
        Math.round(
          (Number(value || 0) + Number.EPSILON) *
            100
        ) / 100
      );
    }

    function money(value) {
      var currencyCode =
        builder.getAttribute(
          'data-currency-code'
        ) || 'USD';

      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currencyCode
        }).format(Number(value || 0));
      } catch (error) {
        return '$' + roundMoney(value).toFixed(2);
      }
    }

    function parseMoney(text) {
      var cleaned = String(text || '')
        .replace(/[^0-9.,-]/g, '')
        .replace(/,/g, '');

      var value = parseFloat(cleaned);

      return Number.isFinite(value)
        ? value
        : 0;
    }

    function escapeSelectorValue(value) {
      if (
        window.CSS &&
        typeof window.CSS.escape === 'function'
      ) {
        return window.CSS.escape(value);
      }

      return String(value || '').replace(
        /["\\]/g,
        '\\$&'
      );
    }

    function findCartItem(estimateRow) {
      var lineKey = estimateRow.getAttribute(
        'data-line-key'
      );

      if (!lineKey) {
        return null;
      }

      return document.querySelector(
        '.cart-item[data-cart-item-key="' +
          escapeSelectorValue(lineKey) +
        '"]'
      );
    }

    function getCartQuantity(cartItem) {
      if (!cartItem) {
        return 1;
      }

      var quantityInput = cartItem.querySelector(
        'input[name="updates[]"]'
      );

      var quantity = quantityInput
        ? parseInt(quantityInput.value, 10)
        : parseInt(
            cartItem.getAttribute(
              'data-cart-quantity'
            ),
            10
          );

      if (
        !Number.isFinite(quantity) ||
        quantity < 1
      ) {
        quantity = 1;
      }

      return quantity;
    }

    function getVisibleDiscountedUnitPrice(
      cartItem
    ) {
      if (!cartItem) {
        return 0;
      }

      var finalUnitPrice =
        cartItem.querySelector(
          '.cart-item__final-price'
        );

      if (finalUnitPrice) {
        var unitPrice = parseMoney(
          finalUnitPrice.textContent
        );

        if (unitPrice > 0) {
          return unitPrice;
        }
      }

      var possibleUnitPrices =
        cartItem.querySelectorAll(
          [
            '.cart-item__details .price:not(.cart-item__old-price)',
            '.cart-item__details .product-option:not(s)',
            '.cart-item__discounted-prices strong',
            '[data-wholesale-price]',
            '[data-final-price]',
            '.waio_price',
            '.waio-price',
            '.wsaio_price',
            '.wsaio-price'
          ].join(',')
        );

      for (
        var i = 0;
        i < possibleUnitPrices.length;
        i += 1
      ) {
        var element = possibleUnitPrices[i];

        if (
          element.matches(
            's, .cart-item__old-price'
          )
        ) {
          continue;
        }

        var visibleValue = parseMoney(
          element.textContent
        );

        if (visibleValue > 0) {
          return visibleValue;
        }
      }

      return 0;
    }

    function getVisibleDiscountedLinePrice(
      cartItem
    ) {
      if (!cartItem) {
        return 0;
      }

      var selectors = [
        '.cart-item__totals.small-hide ' +
          '.cart-item__discounted-prices ' +
          'dd.price.price--end',

        '.cart-item__totals.medium-hide ' +
          '.cart-item__discounted-prices ' +
          'dd.price.price--end',

        '.cart-item__totals ' +
          '.cart-item__price-wrapper ' +
          '.price.price--end:not(s)',

        '[data-wholesale-line-price]',

        '[data-final-line-price]'
      ];

      for (
        var i = 0;
        i < selectors.length;
        i += 1
      ) {
        var element = cartItem.querySelector(
          selectors[i]
        );

        if (!element) {
          continue;
        }

        var linePrice = parseMoney(
          element.textContent
        );

        if (linePrice > 0) {
          return linePrice;
        }
      }

      return 0;
    }

    function getWholesalePrice(estimateRow) {
      var cartItem = findCartItem(estimateRow);

      var visibleUnitPrice =
        getVisibleDiscountedUnitPrice(cartItem);

      if (visibleUnitPrice > 0) {
        return visibleUnitPrice;
      }

      var visibleLinePrice =
        getVisibleDiscountedLinePrice(cartItem);

      if (visibleLinePrice > 0) {
        return (
          visibleLinePrice /
          getCartQuantity(cartItem)
        );
      }

      if (cartItem) {
        var finalUnitCents = parseInt(
          cartItem.getAttribute(
            'data-final-unit-cents'
          ),
          10
        );

        if (
          Number.isFinite(finalUnitCents) &&
          finalUnitCents > 0
        ) {
          return finalUnitCents / 100;
        }

        var finalLineCents = parseInt(
          cartItem.getAttribute(
            'data-final-line-cents'
          ),
          10
        );

        var cartQuantity =
          getCartQuantity(cartItem);

        if (
          Number.isFinite(finalLineCents) &&
          finalLineCents > 0 &&
          cartQuantity > 0
        ) {
          return (
            finalLineCents /
            cartQuantity /
            100
          );
        }
      }

      return centsToDollars(
        estimateRow.getAttribute(
          'data-wholesale-cents'
        )
      );
    }

    function updateWholesalePriceDisplay(
      row,
      wholesalePrice
    ) {
      var element = row.querySelector(
        '.gfd-estimate__wholesale-unit-price'
      );

      if (element) {
        element.textContent = money(
          wholesalePrice
        );
      }
    }

    function setSellingPrice(row, amount) {
      var input = row.querySelector(
        '.gfd-estimate__selling-price'
      );

      if (!input) {
        return;
      }

      input.value =
        roundMoney(amount).toFixed(2);
    }

    function getEstimateQuantity(row) {
      var quantityElement = row.querySelector(
        '.gfd-estimate__quantity'
      );

      var quantity = parseInt(
        quantityElement
          ? quantityElement.getAttribute(
              'data-quantity'
            )
          : row.getAttribute(
              'data-quantity'
            ),
        10
      );

      if (
        !Number.isFinite(quantity) ||
        quantity < 0
      ) {
        quantity = 0;
      }

      return quantity;
    }

    function updateTotals() {
      var lineRows = getLineRows();
      var productSubtotal = 0;

      lineRows.forEach(function (row) {
        var sellingPriceInput =
          row.querySelector(
            '.gfd-estimate__selling-price'
          );

        var sellingPrice = numberValue(
          sellingPriceInput
        );

        var quantity =
          getEstimateQuantity(row);

        var lineTotal = roundMoney(
          sellingPrice * quantity
        );

        productSubtotal += lineTotal;

        var lineTotalElement =
          row.querySelector(
            '.gfd-estimate__line-total'
          );

        if (lineTotalElement) {
          lineTotalElement.textContent =
            money(lineTotal);
        }
      });

      var labor = numberValue(laborInput);
      var delivery = numberValue(
        deliveryInput
      );
      var other = numberValue(otherInput);
      var discount = numberValue(
        discountInput
      );
      var taxRate = numberValue(
        taxRateInput
      );

      var taxableSubtotal = Math.max(
        0,
        productSubtotal +
          labor +
          delivery +
          other -
          discount
      );

      var tax = roundMoney(
        taxableSubtotal *
          (taxRate / 100)
      );

      var grandTotal = roundMoney(
        taxableSubtotal + tax
      );

      var values = {
        GfdEstimateProductSubtotal:
          money(productSubtotal),

        GfdEstimateLaborTotal:
          money(labor),

        GfdEstimateDeliveryTotal:
          money(delivery),

        GfdEstimateOtherTotal:
          money(other),

        GfdEstimateDiscountTotal:
          '-' + money(discount),

        GfdEstimateTaxTotal:
          money(tax),

        GfdEstimateGrandTotal:
          money(grandTotal)
      };

      Object.keys(values).forEach(
        function (id) {
          var element =
            document.getElementById(id);

          if (element) {
            element.textContent =
              values[id];
          }
        }
      );
    }

    function applyMarkup() {
      var markupPercent = numberValue(
        markupInput
      );

      getLineRows().forEach(function (row) {
        var wholesalePrice =
          getWholesalePrice(row);

        updateWholesalePriceDisplay(
          row,
          wholesalePrice
        );

        var sellingPrice =
          wholesalePrice *
          (1 + markupPercent / 100);

        setSellingPrice(
          row,
          sellingPrice
        );
      });

      updateTotals();
    }

    function resetSellingPrices() {
      getLineRows().forEach(function (row) {
        var wholesalePrice =
          getWholesalePrice(row);

        updateWholesalePriceDisplay(
          row,
          wholesalePrice
        );

        setSellingPrice(
          row,
          wholesalePrice
        );
      });

      updateTotals();
    }

    function refreshEstimatePrices() {
      getLineRows().forEach(function (row) {
        var wholesalePrice =
          getWholesalePrice(row);

        updateWholesalePriceDisplay(
          row,
          wholesalePrice
        );
      });

      applyMarkup();
    }

    function waitForWholesalePrices(
      callback
    ) {
      var attempts = 0;
      var maximumAttempts = 15;

      var timer = window.setInterval(
        function () {
          attempts += 1;

          var lineRows = getLineRows();
          var foundUsablePrice = false;

          lineRows.forEach(function (row) {
            var price =
              getWholesalePrice(row);

            if (price > 0) {
              foundUsablePrice = true;
            }
          });

          if (
            foundUsablePrice ||
            attempts >= maximumAttempts
          ) {
            window.clearInterval(timer);
            callback();
          }
        },
        300
      );
    }

    function preparePrintValues() {
      builder
        .querySelectorAll(
          'input, textarea'
        )
        .forEach(function (field) {
          if (
            field.tagName === 'TEXTAREA'
          ) {
            field.textContent =
              field.value;
          } else {
            field.setAttribute(
              'value',
              field.value
            );
          }
        });
    }

    /*
     * Project and estimate saving
     */

    function getProjectStorageKey() {
      var customerId = builder.getAttribute(
        'data-customer-id'
      );

      return (
        'gfd_projects_customer_' +
        customerId
      );
    }

    function loadProjects() {
      try {
        var storedProjects =
          localStorage.getItem(
            getProjectStorageKey()
          );

        var projects = JSON.parse(
          storedProjects || '[]'
        );

        return Array.isArray(projects)
          ? projects
          : [];
      } catch (error) {
        return [];
      }
    }

    function saveProjects(projects) {
      try {
        localStorage.setItem(
          getProjectStorageKey(),
          JSON.stringify(projects)
        );

        return true;
      } catch (error) {
        return false;
      }
    }

    function populateProjectSelect() {
      if (!projectSelect) {
        return;
      }

      var projects = loadProjects();
      var previousValue =
        projectSelect.value;

      projectSelect.innerHTML = '';

      var blankOption =
        document.createElement('option');

      blankOption.value = '';
      blankOption.textContent =
        'Select a project';

      projectSelect.appendChild(
        blankOption
      );

      projects
        .slice()
        .sort(function (a, b) {
          return String(a.name || '')
            .localeCompare(
              String(b.name || ''),
              undefined,
              {
                numeric: true,
                sensitivity: 'base'
              }
            );
        })
        .forEach(function (project) {
          var option =
            document.createElement('option');

          option.value = project.id;
          option.textContent =
            project.name || 'Unnamed Project';

          projectSelect.appendChild(
            option
          );
        });

      var previousStillExists =
        projects.some(function (project) {
          return (
            project.id === previousValue
          );
        });

      if (previousStillExists) {
        projectSelect.value =
          previousValue;
      }
    }

    function getTextFieldValue(id) {
      var element =
        document.getElementById(id);

      return element
        ? String(element.value || '').trim()
        : '';
    }

    function getEstimateLines() {
      return getLineRows().map(
        function (row) {
          var productElement =
            row.querySelector(
              'td:first-child strong'
            );

          var variantElement =
            row.querySelector(
              '.gfd-estimate__variant'
            );

          var skuElement =
            row.querySelector(
              'td:nth-child(2)'
            );

          var sellingPriceInput =
            row.querySelector(
              '.gfd-estimate__selling-price'
            );

          var wholesalePrice =
            getWholesalePrice(row);

          var quantity =
            getEstimateQuantity(row);

          var customerUnitPrice =
            roundMoney(
              numberValue(
                sellingPriceInput
              )
            );

          return {
            lineKey:
              row.getAttribute(
                'data-line-key'
              ) || '',

            variantId: (function () {
              var lineKey = String(
                row.getAttribute('data-line-key') || ''
              );

              var variantId = Number(
                lineKey.split(':')[0]
              );

              return Number.isFinite(variantId)
                ? variantId
                : 0;
            })(),

            productTitle:
              productElement
                ? productElement.textContent.trim()
                : '',

            variantTitle:
              variantElement
                ? variantElement.textContent.trim()
                : '',

            sku:
              skuElement
                ? skuElement.textContent.trim()
                : '',

            quantity: quantity,

            wholesaleUnitPrice:
              roundMoney(
                wholesalePrice
              ),

            wholesaleLineTotal:
              roundMoney(
                wholesalePrice * quantity
              ),

            customerUnitPrice:
              customerUnitPrice,

            customerLineTotal:
              roundMoney(
                customerUnitPrice *
                  quantity
              )
          };
        }
      );
    }

    function makeEstimateId() {
      return (
        'estimate_' +
        Date.now() +
        '_' +
        Math.random()
          .toString(36)
          .slice(2, 8)
      );
    }

    function showSaveMessage(
      message,
      isError
    ) {
      if (!saveMessage) {
        return;
      }

      saveMessage.hidden = false;
      saveMessage.textContent = message;

      saveMessage.setAttribute(
        'data-error',
        isError ? 'true' : 'false'
      );
    }

    function hideSaveMessage() {
      if (!saveMessage) {
        return;
      }

      saveMessage.hidden = true;
      saveMessage.textContent = '';
      saveMessage.removeAttribute(
        'data-error'
      );
    }

    function getSummaryValue(id) {
      var element =
        document.getElementById(id);

      return roundMoney(
        parseMoney(
          element
            ? element.textContent
            : '0'
        )
      );
    }

    function saveEstimateToProject() {
      hideSaveMessage();

      if (!projectSelect) {
        showSaveMessage(
          'The project selector is unavailable.',
          true
        );

        return;
      }

      var projectId =
        projectSelect.value;

      if (!projectId) {
        showSaveMessage(
          'Please select a project first.',
          true
        );

        projectSelect.focus();
        return;
      }

      updateTotals();

      var projects = loadProjects();

      var projectIndex =
        projects.findIndex(
          function (project) {
            return (
              project.id === projectId
            );
          }
        );

      if (projectIndex === -1) {
        showSaveMessage(
          'The selected project could not be found.',
          true
        );

        populateProjectSelect();
        return;
      }

      var project =
        projects[projectIndex];

      if (
        !Array.isArray(
          project.estimates
        )
      ) {
        project.estimates = [];
      }

      var now =
        new Date().toISOString();

      var estimate = {
        id: makeEstimateId(),

        estimateNumber:
          getTextFieldValue(
            'GfdEstimateNumber'
          ),

        projectId: project.id,
        projectName: project.name,

        contractorBusinessName:
          getTextFieldValue(
            'GfdEstimateBusinessName'
          ),

        customerName:
          getTextFieldValue(
            'GfdEstimateCustomerName'
          ),

        customerEmail:
          getTextFieldValue(
            'GfdEstimateCustomerEmail'
          ),

        customerPhone:
          getTextFieldValue(
            'GfdEstimateCustomerPhone'
          ),

        estimateDate:
          getTextFieldValue(
            'GfdEstimateDate'
          ),

        expirationDate:
          getTextFieldValue(
            'GfdEstimateExpiration'
          ),

        markupPercent:
          numberValue(markupInput),

        productSubtotal:
          getSummaryValue(
            'GfdEstimateProductSubtotal'
          ),

        labor:
          numberValue(laborInput),

        delivery:
          numberValue(
            deliveryInput
          ),

        other:
          numberValue(otherInput),

        discount:
          numberValue(
            discountInput
          ),

        taxRate:
          numberValue(
            taxRateInput
          ),

        taxTotal:
          getSummaryValue(
            'GfdEstimateTaxTotal'
          ),

        grandTotal:
          getSummaryValue(
            'GfdEstimateGrandTotal'
          ),

        notes:
          getTextFieldValue(
            'GfdEstimateNotes'
          ),

        status: 'Draft',

        lines: getEstimateLines(),

        createdAt: now,
        updatedAt: now
      };

      project.estimates.unshift(
        estimate
      );

      project.updatedAt = now;

      /*
       * Fill blank project customer fields from
       * the estimate without overwriting existing data.
       */
      if (
        !project.customerName &&
        estimate.customerName
      ) {
        project.customerName =
          estimate.customerName;
      }

      if (
        !project.customerEmail &&
        estimate.customerEmail
      ) {
        project.customerEmail =
          estimate.customerEmail;
      }

      if (
        !project.customerPhone &&
        estimate.customerPhone
      ) {
        project.customerPhone =
          estimate.customerPhone;
      }

      projects[projectIndex] =
        project;

      var saved =
        saveProjects(projects);

      if (!saved) {
        showSaveMessage(
          'The estimate could not be saved. Your browser storage may be full or disabled.',
          true
        );

        return;
      }

      showSaveMessage(
        'Estimate ' +
          (
            estimate.estimateNumber ||
            ''
          ) +
          ' saved to ' +
          project.name +
          '.',
        false
      );
    }

    /*
     * Estimate builder events
     */

    toggleButton.addEventListener(
      'click',
      function () {
        var opening =
          panel.hasAttribute('hidden');

        if (opening) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute(
            'hidden',
            ''
          );
        }

        toggleButton.setAttribute(
          'aria-expanded',
          opening ? 'true' : 'false'
        );

        toggleButton.textContent =
          opening
            ? 'Close Estimate'
            : 'Create Estimate';

        if (opening) {
          populateProjectSelect();

          waitForWholesalePrices(
            function () {
              refreshEstimatePrices();
            }
          );
        }
      }
    );

    if (applyMarkupButton) {
      applyMarkupButton.addEventListener(
        'click',
        function () {
          waitForWholesalePrices(
            applyMarkup
          );
        }
      );
    }

    if (resetPricesButton) {
      resetPricesButton.addEventListener(
        'click',
        function () {
          waitForWholesalePrices(
            resetSellingPrices
          );
        }
      );
    }

    if (saveEstimateButton) {
      saveEstimateButton.addEventListener(
        'click',
        saveEstimateToProject
      );
    }

    if (projectSelect) {
      projectSelect.addEventListener(
        'change',
        hideSaveMessage
      );
    }

    builder.addEventListener(
      'input',
      function (event) {
        if (
          event.target.matches(
            '.gfd-estimate__selling-price,' +
              '#GfdEstimateLabor,' +
              '#GfdEstimateDelivery,' +
              '#GfdEstimateOther,' +
              '#GfdEstimateDiscount,' +
              '#GfdEstimateTaxRate'
          )
        ) {
          updateTotals();
        }
      }
    );

    if (printButton) {
      printButton.addEventListener(
        'click',
        function () {
          openCartPrintDialog();
        }
      );
    }

    /*
     * Automatically refresh the cart after a quantity
     * change and reopen the estimate when necessary.
     */

    var quantityRefreshTimer = null;

    function scheduleEstimateCartRefresh() {
      window.clearTimeout(
        quantityRefreshTimer
      );

      if (
        !panel.hasAttribute('hidden')
      ) {
        sessionStorage.setItem(
          'gfdEstimateWasOpen',
          'true'
        );
      } else {
        sessionStorage.removeItem(
          'gfdEstimateWasOpen'
        );
      }

      if (
        projectSelect &&
        projectSelect.value
      ) {
        sessionStorage.setItem(
          'gfdEstimateSelectedProject',
          projectSelect.value
        );
      } else {
        sessionStorage.removeItem(
          'gfdEstimateSelectedProject'
        );
      }

      quantityRefreshTimer =
        window.setTimeout(
          function () {
            window.location.reload();
          },
          1400
        );
    }

    document.addEventListener(
      'change',
      function (event) {
        if (
          event.target.matches(
            '#main-cart-items input[name="updates[]"],' +
              '#main-cart-items .quantity__input'
          )
        ) {
          scheduleEstimateCartRefresh();
        }
      }
    );

    document.addEventListener(
      'click',
      function (event) {
        var quantityButton =
          event.target.closest(
            '#main-cart-items .quantity__button'
          );

        if (quantityButton) {
          scheduleEstimateCartRefresh();
        }
      }
    );

    /*
     * Initial setup
     */

    populateProjectSelect();

    window.setTimeout(function () {
      refreshEstimatePrices();
    }, 1000);

    if (
      sessionStorage.getItem(
        'gfdEstimateWasOpen'
      ) === 'true'
    ) {
      sessionStorage.removeItem(
        'gfdEstimateWasOpen'
      );

      panel.removeAttribute('hidden');

      toggleButton.textContent =
        'Close Estimate';

      toggleButton.setAttribute(
        'aria-expanded',
        'true'
      );

      populateProjectSelect();

      var savedProjectId =
        sessionStorage.getItem(
          'gfdEstimateSelectedProject'
        );

      if (
        savedProjectId &&
        projectSelect
      ) {
        var matchingOption =
          Array.prototype.some.call(
            projectSelect.options,
            function (option) {
              return (
                option.value ===
                savedProjectId
              );
            }
          );

        if (matchingOption) {
          projectSelect.value =
            savedProjectId;
        }
      }

      sessionStorage.removeItem(
        'gfdEstimateSelectedProject'
      );

      window.setTimeout(function () {
        refreshEstimatePrices();
      }, 1200);
    }
  });
})();
